import axios from 'axios'
import jwtDecode from 'jwt-decode'
import { clients } from '@/services/client.factory'


const auth = {
    namespaced: true,
    state: {
        isAuthenticated: false,
        status: '',
        token: localStorage.getItem('token') || null,
        refreshToken: localStorage.getItem('refreshToken') || null,
        realm: localStorage.getItem('realm'),
        error: null,
        cityCode: null,
        realms: []
    },

    getters: {
        realms: (state) => state.realms,
        realm: state => { return state.realm },
        refreshToken: state => { return state.refreshToken },
        isLoggedIn: state => {
            console.log('state: ', state);
            return !!state.token;
        },
        authStatus: state => { return state.status },
        error: state => state.error,
        jwtDecoded: state => {
            const token = state.token || null
            if (token != null) {
                var decoded = jwtDecode(token)
                return decoded
            }
            return null
        },
        cityCode: (state, getters) => {
            if (getters.jwtDecoded) {
                state.cityCode = getters.jwtDecoded.city_code
            }
        },
    },
    mutations: {
        AUTH_REQUEST(state) {
            state.status = 'loading'
            state.error = null
        },
        AUTH_SUCCESS(state, { token, refreshToken, realm }) {
            state.isAuthenticated = true;
            state.status = 'success'
            state.token = token
            state.refreshToken = refreshToken
            state.realm = realm
        },
        AUTH_ERROR(state, error) {
            state.status = 'error'
            state.error = error
        },
        LOGOUT(state) {
            state.isAuthenticated = false;
            state.status = ''
            state.token = null
            state.error = null
            state.refreshToken = null
            //state.realm = null
        },
        REALMS_SET_ITEMS(state, realms) {
            Object.assign(state, { realms })
        },
    },

    actions: {
        async login({ commit }, data) {
            commit('AUTH_REQUEST', null)
            const params = new URLSearchParams();
            params.append("grant_type", "password");
            params.append("client_id", CLIENT_ID);
            params.append("username", data.username);
            params.append("password", data.password);

            try {
                const realm = data.realm
                const response = await axios({ url: process.env.VUE_APP_KEYCLOAK_ENDPOINT + realm + '/protocol/openid-connect/token', data: params, method: 'POST' })

                if (response) {
                    const token = response.data.access_token
                    const refreshToken = response.data.refresh_token
                    localStorage.setItem('token', token)
                    localStorage.setItem('realm', realm)
                    localStorage.setItem('refreshToken', refreshToken)

                    commit('AUTH_SUCCESS', { token, refreshToken, realm })
                }
            } catch (error) {
                commit('AUTH_ERROR', 'Kullanıcı Adı veya Parola hatalı olabilir!')
                localStorage.removeItem('token')
                //localStorage.removeItem('realm')
                localStorage.removeItem('refreshToken')
                throw (error)
            }
        },
        async logout({ commit }, { realm, refreshToken }) {
            const params = new URLSearchParams();
            params.append("refresh_token", refreshToken);
            params.append("client_id", CLIENT_ID);
            try {
                const response = await axios({ url: process.env.VUE_APP_KEYCLOAK_ENDPOINT + realm + '/protocol/openid-connect/logout', data: params, method: 'POST' })
                if (response) {
                    localStorage.removeItem('token')
                    //localStorage.removeItem('realm')
                    localStorage.removeItem('refreshToken')
                    commit('LOGOUT')
                }

            } catch (error) {
                commit('AUTH_ERROR', 'Çıkış Yapılamadı!')
                throw (error)
            }
        },
        async getRealms({ commit }) {
            await clients.placeServiceClient.getRealms()
                .then((res) => res.data)
                .then((data) =>
                    //console.log("reeeeeeeealm",data)
                    commit('REALMS_SET_ITEMS', data)
                )
        }

    }
}
export default auth;